// extracted by mini-css-extract-plugin
module.exports = {"Description":"Description_Description__3h6sM","Description__Title":"Description_Description__Title__1yRAN"};